export type OwnerTourStep = {
  id: string;
  path: string;
  target?: string;
  title: string;
  body: string;
};

export const OWNER_TOUR_STEPS: OwnerTourStep[] = [
  {
    id: 'welcome',
    path: '/admin/dashboard',
    title: '점주 화면 안내',
    body: '체험 계정으로 들어왔습니다. 제안 자리에서 점주가 매출을 확인할 때 쓰는 화면을 순서대로 살펴봅니다. 숫자는 예시이며, 실제 가맹점 매출이 아닙니다.',
  },
  {
    id: 'store',
    path: '/admin/dashboard',
    target: '[data-tour="store-picker"]',
    title: '매장',
    body: '계정에 연결된 매장 이름과 권한이 나옵니다. 매장이 여러 곳이면 여기서 바꿔 가며 매출을 볼 수 있습니다.',
  },
  {
    id: 'summary',
    path: '/admin/dashboard',
    target: '[data-tour="sales-summary"]',
    title: '매출 요약',
    body: '오늘, 어제, 이번 달, 지난달 매출입니다. 매장에 들어와서 가장 먼저 보는 숫자입니다.',
  },
  {
    id: 'month',
    path: '/admin/dashboard',
    target: '[data-tour="month-board"]',
    title: '월별 매출',
    body: '월을 옮기면 카드, 마일리지, 기타 합계와 날짜별 매출이 바뀝니다. 해당 월 매출은 엑셀로 받을 수 있습니다.',
  },
  {
    id: 'totalsales-nav',
    path: '/admin/dashboard',
    target: '[data-tour="nav-totalsales"]',
    title: '통합매출',
    body: '결제 한 건씩 보는 메뉴입니다. 다음은 기간과 결제수단을 고르는 화면입니다.',
  },
  {
    id: 'totalsales',
    path: '/admin/totalsales',
    target: '[data-tour="total-sales"]',
    title: '결제 건별 조회',
    body: '날짜, 단말기, 결제수단을 고른 뒤 검색합니다. 한 건을 누르면 승인번호와 카드사 등 상세가 열리고, 합계나 엑셀 내려받기도 됩니다.',
  },
  {
    id: 'permachine-nav',
    path: '/admin/totalsales',
    target: '[data-tour="nav-permachine"]',
    title: '단말기별 매출',
    body: '세탁기, 건조기처럼 기기마다 매출을 나눠 보는 메뉴입니다.',
  },
  {
    id: 'permachine',
    path: '/admin/permachine',
    target: '[data-tour="per-machine"]',
    title: '단말기 조회',
    body: '기간을 정하면 단말기별 카드, 마일리지, 기타 금액과 건수가 나옵니다. 단말기를 누르면 그 기기의 결제 내역을 이어서 볼 수 있습니다.',
  },
  {
    id: 'analysis-nav',
    path: '/admin/permachine',
    target: '[data-tour="nav-analysis"]',
    title: '분석',
    body: '연간 추이, 단말기 비교, 시간대별 이용을 보는 메뉴입니다.',
  },
  {
    id: 'analysis',
    path: '/admin/analysis',
    target: '[data-tour="analysis"]',
    title: '매출 분석',
    body: '연 매출 추이는 월별 흐름, 단말기 매출은 기기 간 차이, 사용시간 분석은 손님이 많은 시간대를 보여줍니다.',
  },
  {
    id: 'charge',
    path: '/admin/charge',
    target: '[data-tour="charge"]',
    title: '수수료 조회',
    body: '왼쪽 위 메뉴의 수수료 조회입니다. 연도를 고르면 카드 매출, 수수료, 입금액이 월별로 나옵니다.',
  },
  {
    id: 'done',
    path: '/admin/dashboard',
    title: '안내를 마칩니다',
    body: '매출 요약, 결제 건별 조회, 단말기별 매출, 분석, 수수료까지 살펴봤습니다. 오른쪽 아래 화면 안내로 처음부터 다시 볼 수 있습니다.',
  },
];
